"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _react = _interopRequireDefault(require("react"));
var _Alert = require("./Alert.styled");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var iconMap = {
  basic: _freeSolidSvgIcons.faInfoCircle,
  success: _freeSolidSvgIcons.faCheckCircle,
  warning: _freeSolidSvgIcons.faExclamationCircle,
  failure: _freeSolidSvgIcons.faExclamationTriangle
};
var Alert = exports.Alert = function Alert(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'basic' : _ref$type,
    title = _ref.title,
    content = _ref.content,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_Alert.StyledAlert, {
    type: type,
    size: size
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "header"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: iconMap[type]
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content"
  }, content));
};
Alert.propTypes = {
  type: _propTypes["default"].oneOf(['basic', 'success', 'warning', 'failure']),
  title: _propTypes["default"].string,
  content: _propTypes["default"].any,
  footer: _propTypes["default"].any,
  size: _propTypes["default"].oneOf([null, 'small', 'medium'])
};